// src/pages/DocLibrary/index.tsx
async function clientLoader() {
  return {
    code: 0,
    data: "doc library",
    msg: ""
  };
}

// src/.umi-production/core/loaders.ts
var loaders_default = {
  "9": clientLoader
};
export {
  loaders_default as default
};
